import React from 'react';
import '../CSS/Footer.css';

function Footer() {
  return (
    <footer id="footer">
      <p>©krishna</p>
    </footer>
  );
}

export default Footer;
